import { create } from 'zustand'

export const useSecondaryNavStore = create((set) => ({
  collapsed: false,
  setCollapsed: (collapsed) => set({ collapsed: Boolean(collapsed) }),
  toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed })),
}))
